// @flow
import * as React from 'react';
import { Motion, spring } from 'react-motion';

import CreateProfileSocial from 'components/pages/ConfirmationPage/CreateProfile/components/CreateProfileSocial/CreateProfileSocial';
import SignUp from 'components/pages/ConfirmationPage/CreateProfile/components/SignUp';
import VerifyIdentity from 'components/pages/ConfirmationPage/CreateProfile/components/VerifyIdentity';

import { APP_FLOW } from 'constants/appFlow';

// Utils
import { captureFocusUtilities } from 'utils/adaConfigurations/ModalFocusPrision';

import './CreateProfileContent.scss';

export type Props = {
  appFlow?: string,
  obfuscatedBy?: string
};

type State = {
  /**
   * The component that's currently visible
   */
  componentVisible: 'social' | 'signup' | 'verify',
  top: number,
  height: number
};

type ChildState = {
  top: number,
  height: number
};

class CreateProfileContent extends React.Component<Props, State> {
  static block = 'create-profile-content';

  constructor() {
    super();
    (this: any).captureUtilities = captureFocusUtilities();
  }
  state = {
    top: 0,
    height: 0,
    componentVisible: 'social'
  };

  // eslint-disable-next-line react/sort-comp
  contentRef: React.Ref<'div'> = React.createRef();
  socialRef: React.Ref<'div'> = React.createRef();
  verifyRef: React.Ref<'div'> = React.createRef();
  signupRef: React.Ref<'div'> = React.createRef();
  maskRef: React.Ref<'div'> = React.createRef();

  /**
   * Holds information about each child (computed only once after mount)
   */
  childState: { [string]: ChildState } = {};

  onContentTogglerClick = (next: 'social' | 'signup') => (
    event: MouseEvent
  ) => {
    this.updateMask(next);
  };

  updateMask(next: 'social' | 'signup' | 'verify') {
    const style = this.childState[next];
    this.setState({
      top: -style.top,
      height: style.height,
      componentVisible: next
    });
  }

  setChildState(key: string, element: any) {
    const childState = {
      top: element.offsetTop,
      height: element.offsetHeight
    };
    this.childState[key] = childState;
  }

  componentDidMount() {
    const { appFlow, obfuscatedBy } = this.props;
    this.setChildState('verify', (this.verifyRef: any).current);
    this.setChildState('social', (this.socialRef: any).current);
    this.setChildState('signup', (this.signupRef: any).current);
    this.updateMask(
      appFlow === APP_FLOW.FIND_ME && obfuscatedBy ? 'verify' : 'social'
    );
  }

  componentDidUpdate() {
    const childrenMap = {
      verify: (this.verifyRef: any).current,
      social: (this.socialRef: any).current,
      signup: (this.signupRef: any).current
    };

    (this: any).captureUtilities.free();
    (this: any).captureUtilities.capture(
      childrenMap[this.state.componentVisible],
      (this.maskRef: any).current,
      (this: any).captureUtilities.anyCaptureApplied
    );
  }

  componentWillUnmount() {
    (this: any).captureUtilities.free();
  }

  render() {
    const ns = CreateProfileContent.block;
    const motionDefaultStyle = {
      top: 0
    };
    const motionStyle = {
      top: spring(this.state.top)
    };
    return (
      <div className={ns}>
        <Motion defaultStyle={motionDefaultStyle} style={motionStyle}>
          {style => (
            <div
              className={`${ns}__content-wrap`}
              style={{ height: this.state.height }}
              ref={this.contentRef}
            >
              <div
                className={`${ns}__mask`}
                style={{ top: style.top }}
                ref={this.maskRef}
              >
                <div className={`${ns}__verify`} ref={this.verifyRef}>
                  <VerifyIdentity
                    onNextClick={this.onContentTogglerClick('social')}
                  />
                </div>
                <div className={`${ns}__social`} ref={this.socialRef}>
                  <CreateProfileSocial
                    onSignUpClick={this.onContentTogglerClick('signup')}
                  />
                </div>
                <div className={`${ns}__signup`} ref={this.signupRef}>
                  <SignUp onArrowClick={this.onContentTogglerClick('social')} />
                </div>
              </div>
            </div>
          )}
        </Motion>
      </div>
    );
  }
}

export default CreateProfileContent;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/CreateProfileContent/CreateProfileContent.js